<template>
  <div class="page-header-title">
    <h3 class="m-b-10">{{ $t('scheduledCampaign') }}</h3>
  </div>
  <paginated-table-wrapper
    v-if="license"
    :sort="'desc'"
    :license="license"
    :request="getScheduledCampaignsRequest"
    :is-search="false"
    :csv-handler="downloadCsvHandler"
    v-slot="{ list, isLoading }"
  >
    <spinner-component v-if="isLoading" item-class="table-spinner-layout"></spinner-component>
    <paginated-table
      v-else
      :license="license"
      :list="list"
    ></paginated-table>
  </paginated-table-wrapper>
</template>

<script>
import { computed, defineAsyncComponent } from 'vue'
import { getScheduledCampaigns } from '@/application/services/statistic.js'
import { store } from '@/application/store'
import { useCsvExport } from '@/application/composables/csvExport.js'
import { formatterCSVScheduledCampaigns } from '@/application/utils/csv.js'
import { useI18n } from 'vue-i18n'

export default {
  name: 'ScheduledCampaignsPage',
  components: {
    'paginated-table-wrapper': defineAsyncComponent(() => import('@/application/components/elements/PaginatedTable/Wrapper.vue')),
    'paginated-table': defineAsyncComponent(() => import('@/application/components/elements/message-tables/ScheduledCampaignsTable.vue')),
    'spinner-component': defineAsyncComponent(() => import('@/application/components/layout/SpinnerComponent.vue')),
  },
  setup() {
    const i18n = useI18n()
    const license = computed(() => store.getters.getLicense)
    const getScheduledCampaignsRequest = getScheduledCampaigns
    const {
      downloadCsvHandler,
    } = useCsvExport(
      'scheduled-campaigns.csv',
      formatterCSVScheduledCampaigns,
      {
        send_from_date: i18n.t('sendFromDate'),
        status: i18n.t('status'),
        recipients: i18n.t('recipients'),
        sandbox: i18n.t('sandbox'),
        send_from_time: i18n.t('sendFromTime'),
      }
    )
    return {
      license,
      getScheduledCampaignsRequest,
      downloadCsvHandler,
    }
  },
}
</script>
